import { Divider, Stack } from "@mui/material";
import { useLocation } from "react-router";

import { ROUTE_NAMES } from "../../../../constants";

import {
  HeaderExtraBackgroundFormat,
  HeaderExtraBrokerSettingsIcon,
  HeaderExtraFormat,
} from "./HeaderExtraFormat";

type ForecastHeaderExtraProps = {
  data: { estimatedBonus: string; bonusGoal: string; totalBobPremium: string };
  navigateToBrokerSettingPage: () => void;
};

export const ForecastHeaderExtra: React.FC<ForecastHeaderExtraProps> = ({
  data,
  navigateToBrokerSettingPage,
}) => {
  const location = useLocation();
  const isForecastParent = !location.pathname.split(
    `/${ROUTE_NAMES.BBE_FORECAST}`,
  )[1]?.length;

  const { estimatedBonus, bonusGoal, totalBobPremium } = data;

  return (
    <HeaderExtraBackgroundFormat>
      {isForecastParent && (
        <Stack spacing={3} direction="row" px={2}>
          <HeaderExtraFormat
            title="Estimated Bonus"
            description={estimatedBonus}
          />

          <HeaderExtraFormat title="Goal" description={bonusGoal} />

          <HeaderExtraFormat
            title="Total BOB Premium"
            description={totalBobPremium}
          />
        </Stack>
      )}

      {isForecastParent && <Divider orientation="vertical" flexItem />}

      <HeaderExtraBrokerSettingsIcon
        navigateToBrokerSettingPage={navigateToBrokerSettingPage}
      />
    </HeaderExtraBackgroundFormat>
  );
};
